import React from "react";
import { useParams } from "react-router-dom";
import CardView from "./CardView";
import axios from "./general/HttpClient";
import { Card } from "./Home";

export const CardWrapper = () => {
    let { id } = useParams<{ id: string }>();
    const [card, setCard] = React.useState({} as Card);

    const getCard = async (id: string) => {
        return axios.get("/api/cards/getcard?id=" + id);
    };

    React.useEffect(() => {
        getCard(id || "").then((card) => {
            setCard(card.data);
            console.log("interactive");
        });
    }, []);

    return <CardView card={card} onUpdate={() => {}}></CardView>;
};
